import { render, staticRenderFns } from "./articleAccepted.vue?vue&type=template&id=f3281902&"
import script from "./articleAccepted.vue?vue&type=script&lang=js&"
export * from "./articleAccepted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports